export default __webpack_public_path__ + "static/apple-app-store-icon-4bc811d887010296ae6b3004d48cecd9.png";